<editor [formControl]="formControl" [init]="config"></editor>